<template>
  <qc-dialog class="tc-15-rich-dialog cos yunti-tips" :show="innerShow" type="custom"
    :title="$t('core.default_title')" :width="620" :defaultCancel="false" @close="closeDialog" :closeTriggers="[]">
    <!-- 这里不翻译，一般是公司内部人员看的。 -->
    <h4>
      {{$t('core.cloud_account_warning')}}
      <a href="javascript:void(0)" @click="openOauthLogin">{{$t('core.tencent_cloud_account')}}</a>
      {{$t('core.login_prompt')}}
    </h4>
    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="weak" @click="closeDialog" :title="$t('core.I_know_it')">
            {{$t('core.I_know_it')}}
          </qc-button>
        </div>
      </div>
    </div>
  </qc-dialog>
</template>

<script>
import { getInnerProps } from '@/scripts/tools/utils';
import eventProxy from '@/scripts/tools/eventProxy';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    innerShow: getInnerProps('show'),
  },
  data() {
    return {};
  },
  methods: {
    openOauthLogin() {
      eventProxy.emit('OPEN_OAUTH_LOGIN');
      this.innerShow = false;
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};

</script>

<style lang="scss">
.yunti-tips {
  .tc-15-rich-dialog {
    margin-top: -400px;
  }
}
</style>
